import { render, staticRenderFns } from "./ChangeLotAddres.vue?vue&type=template&id=08d8bfaa&scoped=true"
import script from "./ChangeLotAddres.vue?vue&type=script&lang=js"
export * from "./ChangeLotAddres.vue?vue&type=script&lang=js"
import style0 from "./ChangeLotAddres.vue?vue&type=style&index=0&id=08d8bfaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d8bfaa",
  null
  
)

export default component.exports